var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"vux-swipeout-button",class:{
    'vux-swipeout-button-primary': _vm.type === 'primary',
    'vux-swipeout-button-warn': _vm.type === 'warn',
    'vux-swipeout-button-default': _vm.type === 'default'
    },style:({
      width: (_vm.width + "px"),
      backgroundColor: _vm.backgroundColor,
      opacity: _vm.disabled ? '0.4' : '1'
    }),attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.onButtonClick}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1a79fcf6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.11.1@vux/src/components/swipeout/swipeout-button.vue
// module id = null
// module chunks = 